<span class="text">{{text}}</span>
<span *ngIf="completionPercentage !== undefined" class="percentage">{{completionPercentage}}%</span>